// Rewrite each message so that all letters are lowercase except for the first letter of the first word in each sentence.
// | SLIDE 1 |
export const projectNameMessage =
  "The official name of the project as shown on the civil plans";
export const projectTypeMessage =
  "The type of project (e.g. commercial, residential, etc.)";
export const residenceTypeMessage =
  "The type of residence (e.g. single family, multi-family, etc.)";
export const landDeveloperMessage =
  "The name of the company who was responsible for land development activities under the previous permit";

export const cswMessage =
  "The CSW number that the land development activities were under";
export const totalBldLotsMessage =
  "The total number of buildings/lots or home sites for this project. If this is a commercial project, please enter the total number of buildings. If this is a residential project, please enter the total number of home sites";
export const totalUnitsMessage =
  "The total number of dwelling units for this project";
export const totAcrMessage =
  "The total acreage of the project, including all parcels";
export const distAcrMessage = "The total acreage to be disturbed";

// | Slide 2 |
export const swpppServicesRequestMessage =
  "Will Argus be providing any of the following services for this project? (Please select all that apply)";
export const noiRequestMessage =
  "Will Argus prepare & submit the Notice of Intent (NOI) for this project?";
export const noiFilingDateMessage = "The date to have the NOI filed by";
export const lvvChecklistRequestMessage =
  "Will Argus be preparing the LVV checklist for this project?";
export const notPreparationRequestMessage =
  "Will Argus be preparing a Notice of Termination (NOT) template for this project? Argus cannot submit the NOT; it must be submitted by the permitee";
export const swpppPreparationRequestMessage =
  "Will Argus be preparing the Stormwater Pollution Prevention Plan (SWPPP) for this project?";
export const postingNoticeSignRequestMessage =
  "Will Argus be posting the Notice Sign for this project? The Notice Sign must be posted at the project site prior to construction activities";
export const swpppInspectionRequestMessage =
  "Will Argus be performing inspections for this project?";
export const bmpInstallationRequestMessage =
  "Will Argus be installing the Stormwater Best Management Practices (BMPs) for this project?";
export const bmpMaintenanceRequestMessage =
  "Will Argus be maintaining the Stormwater Best Management Practices (BMPs) for this project?";
export const areaOfDisturbanceMessage =
  "Upload a map of the area of disturbance for this project";

export const offsiteMapMessage =
  "Upload map(s) detailing offsite work for this project";
export const permitteeMessage =
  "The name of the permitee for this projects NOI";
export const specialServicesMessage =
  "Add any service listed or not listed in the dropdown menu you may need for this project";

// | SLIDE 3 |
export const safetyInterestMessage =
  "Will Argus be providing safety services? (Please select all that apply)";
export const level1SafetyMessage =
  "Will Argus be providing Level 1 Safety inspections for this project?";
export const level2SafetyMessage =
  "Will Argus be providing Level 2 Safety inspections for this project?";

// | SLIDE 4 |
export const airQualityServicesRequestMessage =
  "Will Argus be providing air quality related services? (Please select all that apply)";

export const filePermitRequestMessage =
  "Will Argus be preparing & filing the dust permit for this project?";
export const amendPermitRequestMessage =
  "Will Argus be responsible for amending or renewing the dust permit for this project?";
export const dustAuditRequestMessage = "Dust Control Audits";
export const dustSignRequestMessage =
  "Will Argus be providing and maintaining the dust control sign for this project?";

// | SLIDE 5 |
export const startDateMessage =
  "The date the project's construction activities are scheduled to start";
export const endDateMessage =
  "The estimated date this project is to complete construction activities";
export const projectManagerNameMessage =
  "The first & last name of the project manager for this project";
export const projectManagerPhoneMessage =
  "The project manager's office phone number";
export const projectManagerCellMessage =
  "The project manager's cell phone number";
export const projectManagerEmailMessage = "The project manager's email address";
export const siteContactNameMessage =
  "The first & last name of the site contact for this project";
export const siteContactPhoneMessage = "The site contact's phone number";
export const siteContactEmailMessage = "The site contact's email address";
export const dustCertificationNumberMessage =
  "The dust certification number for the site superintendent. *MORE INFO*";
export const dustCertificationExpirationMessage =
  "The expiration date of the dust certification for the site superintendent. *MORE INFO*";
export const phasesMessage =
  "The number of construction phases for this project";
export const parcelNumbersMessage =
  "The parcel number(s) for this project. If this project spans across multiple parcels, please enter each parcel number";
export const activitiesDescriptionMessage =
  "Land Development & Residential construction activities including clearing & grubbing, mass grading, trenching, utility installation, concrete work, street improvements, landscaping, community pools, parks, and other related activities.";
export const offsitesMessage =
  "Will this project include offsite work or offsite staging areas?";
export const stockpileMessage = "Dates when stockpiling will begin on site";
export const clearingGrubbingMessage =
  "Dates when clearing and grubbing will begin on site";
export const gradingMessage = "Dates when grading will begin on site";
export const infrastructureMessage =
  "Dates when infrastructure will begin on site";
export const pavingMessage = "Dates when paving will begin on site";
export const verticalMessage =
  "Dates when vertical construction will begin on site";
export const landscapingMessage = "Dates when landscaping will begin on site";
export const finalStabilizationMessage =
  "Dates when final stabilization will begin on site";
export const gradingPlanMessage = "Upload the project's grading plans here";

// | SLIDE 6 |
export const isLinearMessage =
  "Is the project linear (e.g public/private roadways, utilities, etc.)?";
export const pAddMessage =
  "Add the exact street address or the nearest cross streets for this project, if the map above did not accurately do so. (e.g SWC of 7th Ave. & Olive, 123 Main St., etc.)";
export const pCityMessage = "The name of city where the project is located";
export const pCountyMessage =
  "The name of the county where the project is located";
export const pZipMessage = "The zip code for this project";
export const latMessage =
  "The closest latitude point of the center of the project. You can find this value on Google Maps by right clicking on the map and then selecting the coordinates option. This will copy the coordinates to your clipboard. The latitude value is the first number listed";
export const lngMessage =
  "The closest longitude point of the center of the project. You can find this value on Google Maps by right clicking on the map and then selecting the coordinates option. This will copy the coordinates to your clipboard. The longitude value is the second number listed";

export const crossRoad1Message =
  "The name of the first cross road nearest to the project site";
export const crossRoad2Message =
  "The name of the second cross road nearest to the project site";
export const cornerDirectionMessage =
  "The direction of the corner where the two cross roads meet (e.g. SW, NW, SE, NE)";

// Rewrite each message so that all letters are lowercase except for the first letter of the first word in each sentence.
//| SLIDE 7 |
export const oNameMessage = "The company name of the owner for this project";
export const oTaxIdMessage =
  "The tax identification number for the owning company. This is usually a 9 digit number, but can be longer";
export const oAddMessage = "The owning company's office address";
export const oCityMessage =
  "The city where the owning company's office is located";
export const oStateMessage =
  "The state where the owning company's office is located";
export const oZipMessage = "The zip code for the owning company's office";
export const oPhoneMessage = "The owning company's office phone number";
export const oFaxMessage = "The owning company's office fax number.";
export const oContactNameMessage =
  "The name of the individual who has the authority to make legal decisions on behalf of the owning entity and responsible officer";
export const oContactTitleMessage =
  "The official working title of the individual who has the authority to make legal decisions on behalf of the owning entity";
export const oContactPhoneMessage = "The responsible officer's phone number";
export const oContactEmailMessage = "The responsible officer's email address";
export const oAuthorizedContactNameMessage =
  "The name of the individual who is authorized to sign for permits & SWPPPs. This individual must be an owner, officer, or authorized agent of the company.";
export const oAuthorizedContactTitleMessage =
  "The authorized contact's official working title";

// Rewrite the following messages exactly as they are written, but only capitalize the first word in each sentence.
// | SLIDE 8 |
export const sameAsOwnerMessage =
  "The operator/general contractor is the same as the owner. If this is not true, please fill out the following fields";
export const gcNameMessage =
  "The name of the primary operator/general contractor for this project";
export const gcTaxIdMessage =
  "The tax identification number for the operator/general contractor. This is usually a 9 digit number, but can be longer";
export const gcAddMessage = "The operator's office address";
export const gcCityMessage = "The city where the operator's office is located";
export const gcStateMessage =
  "The state where the operator's office is located";
export const gcZipMessage = "The zip code for the operator's office address";
export const gcPhoneMessage = "Operator's office phone number";
export const gcFaxMessage = "Operator's office fax number";
export const gcContactNameMessage =
  "The name of the individual who has the authority to make legal decisions on behalf of the company and will be the individual certifying the Notice of Intent (NOI)";
export const gcContactTitleMessage =
  "The official working title of the responsible officer";
export const gcContactPhoneMessage = "Responsible officer's phone number";
export const gcContactEmailMessage = "Responsible officer's email address";
export const gcAuthorizedContactNameMessage =
  "The name of the individual who is authorized to sign for permits & SWPPPs. This individual must be an owner, officer, or authorized agent of the company.";
export const gcAuthorizedContactTitleMessage =
  "The authorized contact's official working title";

// | SLIDE 9 |
export const billingCompanyMessage =
  "The name of the billing company. This is usually the same as the owner or operator/general contractor";
export const companyTypeMessage =
  "The type of company (LLC, Corporation, etc.)";
export const billingPhoneMessage = "The billing company's office phone number";
export const billingFaxMessage = "The billing company's office fax number";
export const billingAddMessage = "The billing company's office address";
export const billingCityMessage =
  "The city where the billing company's office is located";
export const billingStateMessage =
  "The state where the billing company's office is located";
export const billingZipMessage =
  "The zip code for the billing company's office address";
export const billingContactNameMessage =
  "The name of the individual to contact for billing purposes";
export const billingContactTitleMessage =
  "The official working title of the billing contact";
export const billingContactPhoneMessage =
  "The billing contact's office phone number";
export const billingContactEmailMessage = "The billing contact's email address";

// | SLIDE 10 |
export const submitterMessage =
  "Your name will be used at the submitter/contact for this form, only if you successfully submit this form (Your information is accessed through your account, and can be changed at any time by accessing your account settings in the sidebar menu)";
export const submitterTitleMessage =
  "Your official working title. (Your information is accessed through your account, and can be changed at any time by accessing your account settings in the sidebar menu)";
export const submitterPhoneMessage =
  "Your phone number. (Your information is accessed through your account, and can be changed at any time by accessing your account settings in the sidebar menu)";
export const submitterEmailMessage =
  "Your email address. (Your information is accessed through your account, and can be changed at any time by accessing your account settings in the sidebar menu)";
